import i18n from '@signavio/i18n'

import { userUtils } from '@signavio/effektif-api'

export default function organizationName(
  { organization, organizationName, user },
  createDefault = true
) {
  if (organization) {
    return organization.name
  }

  if (organizationName) {
    return organizationName
  }

  const name = userUtils.name(user)

  if (!createDefault) {
    return ''
  }

  if (!name) {
    return i18n('Organization')
  }

  return i18n("__user__'s organization", {
    user: name,
  })
}
